import validateFormFields from './form-validation.js';

const Forms = (() => {
  const forms = Array.from(document.querySelectorAll('[data-form]'));

  return {
    init: () => {
      if (forms.length > 0) {
        forms.forEach((formContainer) => {
          const form = formContainer.querySelector('.c-form'),
                submit = formContainer.querySelector(`[data-form-submit]`),
                successMsg = formContainer.querySelector(`[data-form-success]`),
                failMsg = formContainer.querySelector(`[data-form-fail]`),
                loadingMsg = formContainer.querySelector(`[data-form-loading]`);

          submit.onclick = (e) => {

            //console.log("Inside...");

            e.preventDefault();
            
            loadingMsg.classList.remove('hide');

            failMsg.classList.add('hide');
            successMsg.classList.add('hide');

            validateFormFields.init(form.id, form.action)
            .then((res) => {
              loadingMsg.classList.add('hide');

              //console.log(res);

              if (res.data.Status == 'OK' || res.data.status == 'OK' || res.data.Message == 'OK') {
                form.reset();
                successMsg.classList.remove('hide');

                dataLayer.push({ 
                  'event': form.dataset.formGaevent,
                  'formAction': 'success'
                });
              } else {
                failMsg.classList.remove('hide');

                dataLayer.push({ 
                  'event': form.dataset.formGaevent,
                  'formAction': 'fail'
                });
              }

            })
            .catch(() => {
              loadingMsg.classList.add('hide');
            });
          };
        })
      }
    }
  }
})();

export default Forms;



// WEBPACK FOOTER //
// ./src/js/components/form-submission.js